import '../styles/MontreauxSiteHeader.css';
import React, { useEffect, useState } from 'react';

const NAV_LINKS = [
  { recordId: 'landing', pageName: 'Landing', path: '/' },
  { recordId: 'loans', pageName: 'Loans', path: '/loans' },
  { recordId: 'apply', pageName: 'Apply', path: '/apply' },
];

function resolveActive(activePage) {
  if (typeof activePage === 'string' && activePage.trim() !== '') {
    const match = NAV_LINKS.find(
      (link) => link.pageName.toLowerCase() === activePage.trim().toLowerCase()
    );
    return match ? match.recordId : '';
  }
  if (typeof window === 'undefined') return '';
  const path = window.location.pathname.replace(/\/+$/, '') || '/';
  const match = NAV_LINKS.find((link) => link.path === path);
  return match ? match.recordId : '';
}

function MontreauxSiteHeader({ activePage }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const activeId = resolveActive(activePage);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 768) setMenuOpen(false);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <header className="msh-root">
      <div className="msh-inner">
        <a className="msh-wordmark" href="/">
          <span className="msh-wordmark-mark" aria-hidden="true" />
          Montreaux
        </a>

        <nav className="msh-nav" aria-label="Primary">
          {NAV_LINKS.map((link) => (
            <a
              key={link.recordId}
              href={link.path}
              className={`msh-link${activeId === link.recordId ? ' is-active' : ''}`}
              aria-current={activeId === link.recordId ? 'page' : undefined}
            >
              {link.pageName}
            </a>
          ))}
        </nav>

        <button
          type="button"
          className="msh-menu-btn"
          aria-expanded={menuOpen}
          aria-controls="msh-mobile-menu"
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span className="msh-menu-icon" aria-hidden="true">
            <span />
            <span />
            <span />
          </span>
          Menu
        </button>
      </div>

      <nav
        id="msh-mobile-menu"
        className="msh-mobile-panel"
        aria-label="Primary mobile"
        hidden={!menuOpen}
      >
        {NAV_LINKS.map((link) => (
          <a
            key={link.recordId}
            href={link.path}
            className={`msh-mobile-link${activeId === link.recordId ? ' is-active' : ''}`}
            aria-current={activeId === link.recordId ? 'page' : undefined}
            onClick={() => setMenuOpen(false)}
          >
            {link.pageName}
          </a>
        ))}
      </nav>

      <svg className="msh-arc" viewBox="0 0 1200 22" preserveAspectRatio="none" aria-hidden="true" focusable="false">
        <path d="M0 6 C 160 24, 420 24, 620 9 S 1010 1, 1200 12" />
      </svg>
    </header>
  );
}

export default MontreauxSiteHeader;